import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const buttonConfig = {
  residential: ["Rent", "Resale", "Lease"],
  commercial: ["Rent", "Sale", "Lease"],
  land: ["Rent", "Resale", "Lease"],
};

export default function PropertySelector() {
  const [propertyType, setPropertyType] = useState("residential");
  const [adType, setAdType] = useState(buttonConfig["residential"][0]);
  const navigate = useNavigate();

  const handleSubmit = () => {
    // converting values to lowercase and formatted
    const formattedPath = `/${propertyType}/${adType.toLowerCase()}_form`;
    navigate(formattedPath);
  };

  return (
    <div
      className="container mt-5 p-4 border rounded shadow"
      style={{ maxWidth: "700px" }}
    >
      <h4 className="text-center">Property Type</h4>

      {/* Main Tabs */}
      <div className="d-flex justify-content-center gap-2 my-3">
        {Object.keys(buttonConfig).map((key) => (
          <button
            key={key}
            onClick={() => {
              setPropertyType(key);
              setAdType(buttonConfig[key][0]); // Auto select first option
            }}
            className={`btn ${
              propertyType === key ? "btn-success" : "btn-outline-secondary"
            }`}
          >
            {key === "residential" && "Residential"}
            {key === "commercial" && "Commercial"}
            {key === "land" && (
              <>
                Land/Plot <span className="badge bg-danger ms-1">New</span>
              </>
            )}
          </button>
        ))}
      </div>

      <h5 className="text-center mt-4">Select Property Ad Type</h5>

      {/* Sub-Options Based on Selected Type */}
      <div className="d-flex justify-content-center gap-2 mt-3 flex-wrap">
        {buttonConfig[propertyType].map((option) => (
          <button
            key={option}
            className={`btn ${
              adType === option ? "btn-success" : "btn-outline-secondary"
            }`}
            onClick={() => setAdType(option)}
          >
            {option}
          </button>
        ))}
      </div>

      {/* Submit Button */}
      <div className="text-center mt-4">
        <button
          className="btn text-white px-4 py-2"
          style={{ backgroundColor: "#ff006e" }}
          onClick={handleSubmit}
        >
          Start Posting Your Ad FOR FREE
        </button>
      </div>
    </div>
  );
}
